import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { IEpGridModel, IEpGridSelectionOptions, EpGridComponent, IEpGridState, IEPGridDataResult, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { DateFormats, Right } from 'ep-bt-controls';
import { Observable } from 'rxjs';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import {
  FieldAgentClient, PagingParameters,
  SortParameters, SortParametersDirection,
  GetOpportunitiesRequest,
  Opportunity,
} from 'ep-bt-field-agent-proxy';
import { EpEventService } from '@epicor/kinetic';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaOpportunityService } from '../../services/epbt-fa-opportunity.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-dashboard-opportunities-grid',
  templateUrl: './epbt-fa-dashboard-opportunities-grid.component.html',
  styleUrls: ['./epbt-fa-dashboard-opportunities-grid.component.scss']
})
export class EpbtFaDashboardOpportunitiesGridComponent implements OnInit {

  customerId = -1;
  pageSize = 100;
  public gridModel: IEpGridModel;
  EpButtonStyle = EpButtonStyle;
  currency: string;
  dateFormat: string;
  bistrackSettings: any;
  webTrackUser: any;
  isAddVisible = false;

  // for paging
  @Output() loadingChange = new EventEmitter<boolean>();
  opportunityCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  private _searchString: string;
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
    // this.filterService.dashboardOpportunitySearchValue = this._searchString;
  }
  get searchString(): string { return this._searchString; }

  // @ViewChild('customerTemplate', {static: false}) customerTemplate: TemplateRef<any>;
  @ViewChild('dateEstTemplate', { static: true }) dateEstTemplate: TemplateRef<any>;
  @ViewChild('dateActTemplate', { static: true }) dateActTemplate: TemplateRef<any>;
  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('percentageTemplate', { static: true }) percentageTemplate: TemplateRef<any>;


  constructor(private router: Router, private eventService: EpEventService,
    private fieldAgentService: EpbtFieldAgentService, private client: FieldAgentClient,
    public customerService: EpbtFaCustomerService, public filterService: EpbtFaFilterService,
    private sortService: EpbtFaSortService, private opportunityService: EpbtFaOpportunityService) {
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.dateFormat = bistrackSettings.shortDateFormat ? bistrackSettings.shortDateFormat : DateFormats.ShortDate;
      this.pageSize = bistrackSettings.searchPageSize;
      this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
        this.webTrackUser = webTrackUser;
        this.loadGridonPageLoad();
      });
    });
    this.fieldAgentService.checkAddPermissions(Right.EditOpportunities, (flag: any) => {
      this.isAddVisible = flag;
    });
  }

  getGridModel(documentList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'customerCode',
      selectedKeys: [],
    };

    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: documentList,
      columns: [
        { field: 'customerCode', title: 'CUSTOMER CODE', width: 20, hidden: false, class: 'color-blue' },
        { field: 'customer', title: 'CUSTOMER NAME', width: 20, hidden: false, class: 'color-blue' },
        { field: 'subject', title: 'SUBJECT', width: 20, hidden: false, class: 'color-blue' },
        { field: 'probability', title: 'PROBABILITY', width: 20, hidden: false, class: 'color-blue', cellTemplate: this.percentageTemplate },
        { field: 'status', title: 'STATUS', width: 20, hidden: false, class: 'color-blue' },
        { field: 'totalRevenueInCurrency', title: 'TOTAL REVENUE', width: 20, hidden: false, class: 'color-blue', cellTemplate: this.currencyTemplate },
        { field: 'estimatedCloseDate', title: 'EST CLOSE DATE', width: 20, hidden: false, class: 'color-blue', cellTemplate: this.dateEstTemplate },
        { field: 'actualCloseDate', title: 'ACT CLOSE DATE', width: 20, hidden: false, class: 'color-blue', cellTemplate: this.dateActTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          if (eventArg.event.column.displayTitle != 'PDF') {
            this.router.navigate(['/home/documents/addopportunity', eventArg.event.dataItem.customerID, eventArg.event.dataItem.opportunityID]);
          }
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridData(epGrid, state, false);
        return observerResult;
      }
    };
    return model;
  }

  onCardClick(model) {
    this.router.navigate(['/home/documents/addopportunity', model.customerID, model.opportunityID]);
  }

  getGridData(epGrid: EpGridComponent, state: IEpGridState, isMobile: boolean): Observable<IEPGridDataResult> {

    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.opportunityCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        this.client.getOpportunities(this.inputRequestForOpportunities(this.customerId, this.searchString, state.skip)).subscribe(opportunityRes => {
          if (opportunityRes && opportunityRes.lines.length > 0) {
            const opportunity = opportunityRes.lines;
            this.totalPages = opportunityRes.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (opportunity.length < state.take) {
              this.lastRecords = opportunity;
            } else {
              this.opportunityCollection = [...this.opportunityCollection, ...opportunity];
            }
            if (!isMobile) {
              this.mobileData = this.opportunityCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.opportunityCollection.length;
            const result: IEPGridDataResult = {
              data: opportunity,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  inputRequestForOpportunities(customerId: any, searchString: string, index: number): any {
    const documentOpportunitiesRequest = new GetOpportunitiesRequest();
    documentOpportunitiesRequest.webTrackUser = this.webTrackUser;
    documentOpportunitiesRequest.webTrackUser.customer.customerId = customerId;
    // Paging
    documentOpportunitiesRequest.pagingParameters = new PagingParameters();
    documentOpportunitiesRequest.pagingParameters.index = index;
    documentOpportunitiesRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;

    // Sorting
    documentOpportunitiesRequest.sortParameters = new SortParameters();
    documentOpportunitiesRequest.sortParameters.sortColumn = this.sortService.dashboardOpportunitySortValue; // "DateTimeCreated";
    documentOpportunitiesRequest.sortParameters.direction = this.sortService.dashboardOpportunityDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    // Search parameters
    documentOpportunitiesRequest.searchBranch = this.filterService.selectedDashboardOpportunityBranchId ? this.filterService.selectedDashboardOpportunityBranchId.toString() : '-1';
    documentOpportunitiesRequest.searchType = this.filterService.selectedDashboardOpportunityStatusId ? this.filterService.selectedDashboardOpportunityStatusId.toString() : '-2';
    documentOpportunitiesRequest.searchText = searchString == undefined ? this.filterService.dashboardOpportunitySearchValue : searchString;
    this.filterService.dashboardOpportunitySearchValue = searchString == undefined ? this.filterService.dashboardOpportunitySearchValue : searchString;

    // StatusID
    return documentOpportunitiesRequest;
  }
  getHeight(): number {
    const height = $(window).outerHeight() - 192;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;
  }

  navigateTo() {
    this.customerService.isOpportunityDashboard = true;
    this.opportunityService.docOpportunity = new Opportunity();
    this.router.navigate(['/home/documents/addopportunity', this.customerId]);
  }

  clearGridDetails() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.opportunityCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  updateGridData() {
    this.clearGridDetails();
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        // let contactsList;
        this.getGridData(epGrid, state, true).subscribe(res => {
          if (res.data && res.data.length > 0) {

            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  loadGridonPageLoad() {
    if (this.filterService.selectedDashboardOpportunityStatusId != -2 || this.filterService.selectedDashboardOpportunityBranchId != -1 || this.filterService.dashboardOpportunitySearchValue != null) {
      this.gridModel = this.getGridModel([]);
    }
  }
}
